<script>
    import { Notes } from "../../../Components/Common/index.svelte";

    import { NoteTypes } from "../../../Utils/utilConstants.svelte";

    export let patientID;
    export let patientHasNotes = false;
    export let reloadPatientDetails = () => {};
</script>

<Notes
    noteOwnerID={patientID}
    noteType={NoteTypes.Patient}
    sectionTitle="Patient Notes"
    hasNotes={patientHasNotes}
    onFinishModifyNote={reloadPatientDetails}
/>
